import { inject, signal } from "@angular/core";
import { WsService } from "../ws.service";

export class BaseEventsReceiver<ToListData, OutType> {
    wsService = inject(WsService);
     
    eventsList = signal<ToListData[]>([]);

    private messageQueue: any[] = [];
    private isProcessing = false;

    receiveMessage(message: ToListData) {
        try {
            this.messageQueue.push(message);
            this.processQueue();
        } catch (error) {
            console.warn(error)
        }
    }

    sendMessage(data: {messageSend: OutType, messageToHistory: ToListData}) {
         this.eventsList.set([
            ...this.eventsList(), 
                data.messageToHistory
        ])

        setTimeout(() => {
            this.wsService.SendMessage(JSON.stringify(
                data.messageSend
            ));
        }, 100);
    }
    
    private async processQueue() {
        if (this.isProcessing) return;
        this.isProcessing = true;

        while (this.messageQueue.length > 0) {
            const message = this.messageQueue.shift();
            this.addMessage(message);
            await new Promise((resolve) => setTimeout(resolve, 0)); 
        }
        this.isProcessing = false;
    }

    private addMessage(message: any) {
        this.eventsList.set([...this.eventsList(), message]); 
    }
    // addOrUpdateMessage(message: any) {
    //     this.messages.update((messages) => {
    //         const existing = messages.find((m) => m.id === message.data.message.id);

    //         if (existing) {
    //             return messages.map((m) =>
    //                 m.id === message.data.message.id
    //                 ? 
    //                 {
    //                     ...m,
    //                         content: {
    //                             ...m.content,
    //                             text: (m.content.text || '') + (message.data.message.text ?? ''),
    //                     },
    //                     updatedAt: this.helpersService.getCurrentDateTimeLocalFormat(),
    //                 }
    //                 : m   
    //             );
    //         } else {
    //             return [...messages, this.incomingEventToIMessage(message)];
    //         }
    //     });
    // }

    clearMessages() {
        this.eventsList.set([]);
    }

}